const RECAPTCHA_SCRIPT_URL = 'https://www.google.com/recaptcha/api.js?onload=onRecaptchaLoaded&render=explicit';

// Shared across every component so multiple forms on a page (e.g. a block plus the footer)
// load the script once and don't overwrite each other's window.onRecaptchaLoaded callback
let recaptchaPromise = null;

export function loadRecaptcha() {
    if (recaptchaPromise) {
        return recaptchaPromise;
    }

    recaptchaPromise = new Promise(resolve => { // eslint-disable-line compat/compat
        if (window.grecaptcha && window.grecaptcha.render) {
            resolve(window.grecaptcha);
            return;
        }

        window.onRecaptchaLoaded = () => resolve(window.grecaptcha);

        if (document.querySelector(`script[src^="https://www.google.com/recaptcha/api.js"]`)) {
            return;
        }

        const script = document.createElement('script');
        script.src = RECAPTCHA_SCRIPT_URL;
        script.async = true;
        script.defer = true;
        document.head.appendChild(script);
    });

    return recaptchaPromise;
}
